import React, { ReactElement, Fragment } from 'react';
import * as classnames from 'classnames/bind';
import ReactTooltip from 'react-tooltip';

import qaAttributes from 'component/helper/qa-attributes';

import style from './index.pcss';

export interface IPayload {
    // tslint:disable-next-line no-any
    [key: string]: any
}

export const cn = classnames.bind(style);

export const baseProps = {
    xmlns  : 'http://www.w3.org/2000/svg',
    viewBox: '0 0 24 24',
    width  : 24,
    height : 24,
    ...qaAttributes('icon')
};

export default (children: (payload: IPayload) => ReactElement, optionsProps?: {}) => {
    return (props: IPayload = {}) => {
        return (
            <Fragment>
                <ReactTooltip />
                <svg {...(props.tooltip && { 'data-tip': props.tooltip })}  {...baseProps} {...optionsProps} {...props}>
                    {children(props)}
                </svg>
            </Fragment>
        );
    };
};
